const DEFAULT = 'NOT_STARTED';
const LOADING = 'LOADING';
const SUCCESS = 'SUCCESS';
const ERROR = 'ERROR';

const Status = Object.freeze({ DEFAULT, LOADING, SUCCESS, ERROR });

export default Status;